module.exports = __webpack_public_path__ + "media/images/Email-outline-fb78a154.svg";